import { Button, Classes, ControlGroup, MenuItem, Position } from '@blueprintjs/core';
import { Select } from '@blueprintjs/select';
import PropTypes from 'prop-types';
import React from 'react';
import get from 'utils/get';
import styled from 'styled-components';

const ButtonText = styled.span`
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const StyledButton = styled(Button)`
  justify-content: space-between;
  .bp5-button-text {
    overflow: hidden;
  }
`;
const FamilyTreeSelect = ({
  className,
  disabled,
  fill,
  onChange,
  trees,
  selectedTree,
  labelKey,
}) => {
  const itemPredicate = (query, tree) => {
    return tree[labelKey].toLowerCase().indexOf(query.toLowerCase()) >= 0;
  };

  const renderOption = (tree, { handleClick, modifiers }) => {
    return (
      <MenuItem
        active={modifiers.active}
        disabled={modifiers.disabled}
        key={tree.id}
        onClick={handleClick}
        text={tree[labelKey]}
      />
    );
  };

  return (
    <ControlGroup className={className} fill={fill}>
      <Select
        activeItem={selectedTree}
        disabled={disabled}
        filterable={false}
        className={fill ? Classes.FILL : undefined}
        itemPredicate={itemPredicate}
        itemRenderer={renderOption}
        items={trees}
        noResults={<MenuItem disabled text="No results." />}
        onItemSelect={onChange}
        popoverProps={{ minimal: false, position: Position.BOTTOM_LEFT, targetTagName: 'div' }}
      >
        <StyledButton
          disabled={disabled}
          fill={fill}
          rightIcon="caret-down"
          text={<ButtonText>{get(selectedTree, labelKey, 'Select a Family Tree')}</ButtonText>}
        />
      </Select>
    </ControlGroup>
  );
};

FamilyTreeSelect.defaultProps = {
  className: undefined,
  disabled: false,
  fill: false,
  onChange: () => {},
  trees: [],
  selectedTree: undefined,
  labelKey: 'name',
};

FamilyTreeSelect.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  fill: PropTypes.bool,
  onChange: PropTypes.func,
  trees: PropTypes.arrayOf(PropTypes.object),
  selectedTree: PropTypes.object,
  labelKey: PropTypes.string,
};

export default FamilyTreeSelect;
